import React from 'react';
import { Text } from '@components/typography';
import { StyledOL } from './EULAContent.styles';

export const EULAContent: React.FC = () => {
  return (
    <>
      <Text marginTop={[10, 0]} tagName="h1" variant="hed72Hero" color="purple6">
        EULA
      </Text>
      <Text tagName="h2" variant="dek20" color="purple6">
        Terms of Use and End User License Agreement (EULA)
      </Text>
      <Text marginTop={[6]} tagName="h2" variant="dek20" color="purple6">
        Last Updated: October 12, 2015
      </Text>
      <Text tagName="p" variant="featureCopy17" color="purple6">
        PLEASE READ THESE TERMS OF USE (&quot;TERMS&quot;) CAREFULLY. THIS CONSTITUTES A BINDING AGREEMENT BETWEEN YOU AND JOY LIFE, INC.
        (&quot;JOY,&quot; &quot;WE&quot; OR &quot;US&quot;) FOR THE USE OF THE JOY APPLICATION (THE &quot;APP&quot;) AND ANY RELATED JOY WEB
        OR MOBILE SITES WHICH LINK TO THESE TERMS (THE &quot;SITES&quot;). THE APP AND THE SITES WILL COLLECTIVELY BE REFERRED TO AS THE
        &quot;SERVICE.&quot; BY DOWNLOADING, ACCESSING OR USING THE APP OR OTHERWISE ACCESSING ANY PORTION OF THE SERVICE, YOU AGREE TO BE
        LEGALLY BOUND BY ALL TERMS AND CONDITIONS CONTAINED IN THIS EULA.
      </Text>
      <Text marginTop={[6]} tagName="p" variant="featureCopy17" color="purple6">
        ARBITRATION NOTICE: EXCEPT FOR CERTAIN TYPES OF DISPUTES DESCRIBED IN THE ARBITRATION CLAUSE BELOW, YOU AGREE THAT DISPUTES BETWEEN
        YOU AND JOY WILL BE RESOLVED BY MANDATORY BINDING ARBITRATION AND YOU WAIVE ANY RIGHT TO PARTICIPATE IN A CLASS-ACTION LAWSUIT OR
        CLASS-WIDE ARBITRATION
      </Text>
      <Text tagName="h3" variant="sectionEyeBrow24" color="purple6">
        Changes to Terms:
      </Text>
      <Text tagName="p" variant="featureCopy17" color="purple6">
        To the full extent permitted by applicable law, we reserve the right to change or modify any of the terms and conditions contained
        in these Terms or any related policy or guideline, at any time and in our sole discretion by providing notice these Terms have been
        modified. Such notice may be provided by sending an email, by posting a notice in the App or the Sites, by posting the revised Terms
        in the App and on the Sites and revising the date at the top, or by such other form of notice as we may determine is appropriate.
        Your continued use of the App following the posting of the revised Terms or other notice of such changes will constitute your
        acceptance of such changes or modifications.
      </Text>
      <StyledOL className="feature-hed-17">
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Privacy Policy, Contacts and Location Information.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            Please refer to our Privacy Policy for information on how we collect, uses and disclose information from users of the Service.
            Note that if you give your permission, Joy may access your contacts from your mobile device&apos;s address book and from social
            media accounts in order to enable you to invite and share information with your friends and family. Joy may also collect your
            location information with your permission and may use this for purposes such as sending you notifications, information,
            advertising and deals that are relevant to your location. See our Privacy Policy for more information on these features and on
            how to disable them.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Copyright and Limited License. (a)
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            The App contains the valuable proprietary content of Joy and its licensors and users and is protected by copyright and other
            intellectual property laws and treaties. You agree not to use the App except in its intended manner in accordance with these
            Terms.(b) The App is licensed, not sold to you. Subject to the terms, conditions and limitations set forth in these Terms, Joy
            grants you a limited, non-exclusive, non-transferable and non-sublicensable license to use the App on any mobile device that you
            own or control and to access and use the Sites, solely for your personal, noncommercial use. The terms of the license will also
            govern any upgrades we provide that replace and/or supplement the original App, unless such upgrade is accompanied by a separate
            license in which case the terms of that license will govern. We reserve the right to terminate this license at any time in our
            sole discretion.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            License Limitations.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            You agree not to do, or authorize or permit any third party to do, any of the following: (i) rent, lease, lend, sell,
            redistribute or sublicense the App or the Sites or make any commercial use thereof; (ii) copy, decompile, reverse engineer,
            disassemble, attempt to derive the source code of, modify, or create derivative works of any portion of the App or the Sites
            (except to the extent any such restrictions are prohibited by applicable law); (iii) modify, alter or create any derivative
            works of the App or the Sites; (iv) remove, alter or obscure any copyright, trademark or other proprietary rights notice on or
            in the App or the Sites; (v) use any data mining, robots or similar data gathering or extraction methods; or (vi) use the App or
            the Sites other than for their intended purpose or in a manner that interferes with the use and enjoyment of the Service by
            other users. If you violate any of the foregoing restrictions, your use of the Service will be unlicensed and will infringe our
            copyright and other rights, which may subject you to prosecution and damages. We reserve all rights not expressly granted to you
            herein.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Alerts and Notifications; Consent to Use of Mobile Communications.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            As part of the Service, you may (if enabled) receive push notifications, text messages, alerts, emails, or other types of
            messages directly sent to you outside or inside the App (&quot;Push Messages&quot;). You have control over the Push Messages
            settings, and can opt in or out of these Push Messages through the Services (with the exception of important service
            announcements and administrative messages). You consent to our communicating with you about the App or in connection with the
            features, functions and activities contained therein by SMS, text message, email or other electronic means. Your carrier&apos;s
            normal, messaging, data and other rates and fees will apply to these communications.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Third Party Sites and Services; Third Party Materials.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            The Sites and the Service may provide links to third party web sites, applications, service providers, or other third party
            products and services (&quot;Third Party Services&quot;) and may also display, link to or otherwise make available third party
            content, data, information, events, applications or materials (&quot;Third Party Materials&quot;). Joy does not endorse or
            control and makes no representations or warranties of any kind regarding any Third Party Services or Third Party Materials,
            including regarding the content, accuracy, quality, nature, appropriateness, decency, functionality, performance, reliability,
            completeness, timeliness, validity, safety, legality, or any other aspect thereof. If you access or use any third party web
            site, you should be aware that Joy&apos;s terms and policies no longer govern. You should review the applicable terms and
            policies, including privacy and data gathering practices, of any third party web site to which you navigate from the Service.
          </Text>
        </li>

        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            User Content and Conduct.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            You are solely responsible, and assume all liability, for all text, photos, videos, graphics, messages, materials, data,
            information, and other content or materials (&quot;User Content&quot;) that you post or transmit using the Service, or that are
            posted or transmitted using your account, as well as for your conduct and the conduct of anyone using your account. You agree
            that Joy is not in any way responsible for any User Content, or for any loss or damage thereto, or for the conduct or content of
            other users that you may encounter as a result of using the Service. Company is also not liable for any mistakes, defamation,
            slander, libel, omissions, falsehoods, obscenity, pornography or profanity you may encounter. Your use of the Service is at your
            own risk.<br></br>
            <br></br>
            You agree that the User Content you post or transmit using the Service will not infringe or violate the rights of any third
            party (including copyrights, trademarks and rights of privacy or publicity), violate any applicable law, rule or regulation, and
            will not be unlawful, defamatory, obscene, pornographic, indecent, lewd, suggestive, harassing, threatening, harmful, abusive,
            inflammatory, false, misleading, or fraudulent or contain any viruses, corrupted data or other harmful, disruptive or
            destructive files. If you post any third-party materials, such as professional photographs, you must first obtain permission
            from the copyright owner in such materials to do so. You understand and agree that the Service is intended solely to post User
            Content regarding weddings and other social events (&quot;Events&quot;) and that you may only use the Service to post and share
            User Content related to such Events.<br></br>
            <br></br>
            You further agree that you will not do any of the following in connection with your use of the Service or its users:
          </Text>
          <ul className="feature-copy-17 no-padding">
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Use the App in any manner that could interfere with, disrupt, negatively affect or inhibit other users from fully enjoying
                the App or that could damage, disable, overburden, impair or circumvent the intended the functioning of the App in any
                manner;
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Stalk, intimidate, threaten, or otherwise harass or cause discomfort to other users;
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Use the service to advertise, solicit, or transmit any commercial advertisements, including chain letters, pyramid schemes,
                junk e-mail, spam or repetitive messages;
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Impersonate any person or entity or otherwise misrepresent your affiliation with a person or entity;
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Use or attempt to use another user&apos;s account, or access or view another user&apos;s messages, without authorization;
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Compromise the security of the Service or attempt to circumvent any security or identification features or techniques we
                employ;
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Use the App or the Service for any illegal or unauthorized purpose or engage in, encourage, or promote any illegal activity;
                or
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Violate the publicity, privacy, or data-protection rights of others.
              </Text>
            </li>
          </ul>
          <Text tagName="p" variant="featureCopy17" color="purple6">
            Enforcement of these user content and conduct rules is solely at our discretion, and these rules do not create any private right
            of action on the part of any third party or any reasonable expectation that the App will not contain any content or conduct that
            is prohibited by such rules. As a provider of interactive services, Joy is not liable for any statements, representations or
            User Content provided by its users in connection with the Service. Although we have no obligation to do so, we reserve the right
            to remove, screen, or disable access to any User Content at any time and for any reason without notice, and you are solely
            responsible for creating backup copies of any User Content you transmit through the Service.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Ownership and Use of User Content.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            You retain all ownership rights in your User Content. However, by submitting User Content, you hereby grant us an irrevocable,
            nonexclusive, worldwide, perpetual, royalty-free, sublicensable, and transferable license to publish, reproduce, distribute,
            transmit, store, adapt, translate, publicly perform, publicly display and otherwise use your User Content in any manner or media
            in connection with providing the Service and as otherwise described in these Terms.
          </Text>
          <br></br>
          <br></br>
          <Text tagName="p" variant="featureCopy17" color="purple6">
            You understand that any User Content you post to the Service will be publicly available unless it is designated otherwise
            through the applicable privacy settings established by the owner of the page for the wedding or other Event (the &quot;Event
            Page&quot;) where the User Content is posted (typically the wedding couple or Event host). The settings are available on the
            Event admin page on the Joy web site You also grant Joy and its affiliates and sublicensees the right to use the name that you
            submit in connection with such content. You understand and agree that the use of a user’s name, likeness, voice or identity in
            connection with various features on the Service does not imply any endorsement of such feature or of the Site of the Company
            unless explicitly stated otherwise.
          </Text>
          <Text tagName="p" variant="featureCopy17" color="purple6">
            You represent and warrant that (a) you own and control all of the rights to the User Content that you post or you otherwise have
            the right to post such User Content to the Site and grant the rights you grant in these Terms; (b) the User Content is accurate
            and not misleading; and (c) your use and posting of the User Content does not violate these Site Terms; and (d) neither your use
            and posting of any User Content, nor the use thereof by Joy or its users in connection with the Service, will not infringe upon
            or violate any rights of, or cause injury to, any person or entity.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Feedback.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            You agree that any feedback, suggestions, ideas, or other information or materials regarding the App or the Service that you
            provide, whether by email or otherwise (&quot;Feedback&quot;), are non-confidential and shall become the sole property of Joy.
            We will be entitled to the unrestricted use and dissemination of such Feedback for any purpose, commercial or otherwise, without
            acknowledging or compensating you. You waive and assign to us any rights you may have to the Feedback (including any copyrights
            or moral rights).
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Termination or Modification of Service.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            Joy reserves the right to modify, suspend, remove, or discontinue the App or other aspects of the Service or to terminate your
            account or disable or suspend your access to the App at any time without notice, including terminating or suspending the hosting
            of your Event Page). In no event will Joy be liable for the removal of or disabling of access to the App or any portion or
            feature thereof or your User Content. Joy may also at any time upon notice impose time limits, files size limits, conditions or
            fees with respect to the hosting of Event Pages or other aspects or features of the Service.
          </Text>
          <br></br>
          <br></br>
          <Text tagName="p" variant="featureCopy17" color="purple6">
            In the event of any termination for any reason: (a) the license granted to you in these Terms will terminate; (b) you must
            immediately upon receiving any notice of termination cease all use of the App and destroy or erase all copies of the App in your
            possession or control; and (c) Sections 2(a) and 3 - 23 of these Terms will survive any such termination. Any use of the App
            after termination is unlicensed and is in violation of the copyright and other rights of Joy.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Your Account.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            When you create an account, you agree to: (a) provide accurate, current and complete information about you as may be prompted
            when you register (&quot;Registration Data&quot;); (b) maintain the security of your password and identification; and (c)
            maintain and promptly update the Registration Data to keep it accurate, current and complete. You are responsible for making
            sure that you keep your password secure and safe, and you accept all responsibility for any activity that occurs through your
            account, with or without your knowledge. You agree that you will not do anything that might jeopardize the security of your
            account, including sharing your password with or logging in through unauthorized third-party applications or clients. If you use
            any such application or client, you acknowledge and agree that we will bear no responsibility for any actions taken by those
            applications or clients, such as any breach of or unauthorized use of your account information or messages.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Repeat Infringer Policy.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            In accordance with the Digital Millennium Copyright Act (&quot;DMCA&quot;) and other applicable law, Joy has adopted a policy of
            terminating, in appropriate circumstances and at our sole discretion, subscribers or account holders who are deemed to be repeat
            infringers. We may also in our sole discretion limit access to the Site and/or terminate the accounts of any users who infringe
            any intellectual property rights of others, whether or not there is any repeat infringement.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Copyright Complaints.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            If you believe that anything on the Service infringes upon any copyright which you own or control you may file a notification of
            such infringement with our Designated Agent as set forth below.
          </Text>
          <ul className="feature-copy-17 no-padding">
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Name of Agent Designated to Receive Notification of Claimed Infringement: Vishal Joshi
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Full Address of Designated Agent to Which Notification Should be Sent: 790 Brannan Street, San Francisco CA 94103
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Telephone Number of Designated Agent: 206-588-6869
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                E-Mail Address of Designated Agent:
                <a href="mailto:dmca@withjoy.com">{` dmca@withjoy.com `}</a>
              </Text>
            </li>
          </ul>
          <Text tagName="p" variant="featureCopy17" color="purple6">
            Please see 17 U.S.C. &#167;512(c)(3) for the requirements of a proper notification. You should note that if you knowingly
            misrepresent in your notification that the material or activity is infringing, you will be liable for any damages, including
            costs and attorneys&apos; fees, incurred by us or the alleged infringer as the result of our relying upon such misrepresentation
            in removing or disabling access to the material or activity claimed to be infringing.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Trademarks.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            JOY, the Joy logos and any other Joy product or service name or slogan contained in the Service are trademarks of Joy, and may
            not be copied, imitated or used, in whole or in part, without the prior written permission of Joy or the applicable trademark
            holder. You may not use any metatags or any other &quot;hidden text&quot; utilizing &quot;Joy&quot; or any other name, trademark
            or product or service name of Joy without our prior written permission. In addition, the look and feel of the Service, including
            all page headers, custom graphics, button icons and scripts, is the service mark, trademark and/or trade dress of Joy and may
            not be copied, imitated or used, in whole or in part, without our prior written permission. All other trademarks, registered
            trademarks, product names and company names or logos mentioned in the Service are the property of their respective owners.
            Reference to any products, services, processes or other information, by trade name, trademark, manufacturer, supplier or
            otherwise does not constitute or imply endorsement, sponsorship or recommendation thereof by us.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Indemnification.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            You agree to defend, indemnify and hold harmless Joy, and its employees, contractors, service providers, consultants, directors,
            and agents, from and against any claims, damages, costs, liabilities and expenses (including, but not limited to, reasonable
            attorneys&apos; fees) arising out of or related to: (a) any User Content or messages you transmit through the Service; (b) your
            conduct in connection with the Service; (c) your violation of these Terms; or (d) your violation of the rights of any third
            party.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            DISCLAIMERS.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE SERVICE IS AT YOUR SOLE RISK. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE
            LAW, THE APP IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE,&quot; WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND. JOY
            HEREBY DISCLAIMS ALL REPRESENTATIONS, WARRANTIES AND CONDITIONS WITH RESPECT TO THE APP, EITHER EXPRESS, IMPLIED OR ARISING BY
            LAW, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES AND/OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE, ACCURACY, COMPLETENESS, QUIET ENJOYMENT, AND NON-INFRINGEMENT OF THIRD PARTY RIGHTS.<br></br>
            <br></br>
            JOY CANNOT AND DOES NOT WARRANT THAT THE APP WILL FUNCTION CORRECTLY AND WITHOUT DELAYS OR DISRUPTIONS, WILL AT ALL TIMES BE
            SECURE, ERROR FREE AND PREVENT UNAUTHORIZED ACCESS, OR THAT ALL DEFECTS IN THE APP WILL BE CORRECTED. NO ORAL OR WRITTEN
            STATEMENTS, INFORMATION, GUIDELINES OR ADVICE GIVEN BY JOY OR ITS AUTHORIZED REPRESENTATIVE SHALL CREATE ANY WARRANTY.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            LIMITATION OF LIABILITY.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL JOY BE LIABLE FOR ANY DIRECT, INCIDENTAL, SPECIAL, INDIRECT,
            CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES WHATSOEVER, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, LOSS OF
            DATA, BUSINESS INTERRUPTION OR ANY OTHER COMMERCIAL DAMAGES OR LOSSES, ARISING OUT OF OR RELATED TO YOUR USE OF OR INABILITY TO
            USE THE APP OR THE SERVICE, HOWEVER CAUSED, REGARDLESS OF THE THEORY OF LIABILITY (CONTRACT, TORT OR OTHERWISE), AND OTHER USER
            CONTENT, EVEN IF JOY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.<br></br>
            <br></br>
            IN NO EVENT SHALL JOY&apos;S TOTAL LIABILITY, WHETHER IN CONTRACT, WARRANTY, TORT (INCLUDING NEGLIGENCE, WHETHER ACTIVE, PASSIVE
            OR IMPUTED), PRODUCT LIABILITY, STRICT LIABILITY OR OTHER THEORY, ARISING OUT OF OR RELATING TO THE USE OF OR INABILITY TO USE
            THE APP EXCEED THE GREATER OF TEN DOLLARS OR THE TOTAL LICENSE FEE, IF ANY, THAT YOU HAVE PAID TO JOY FOR USE OF THE APP. THE
            FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Export Limitations.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            You may not use or otherwise export or re-export the App except as authorized by United States law and the laws of the
            jurisdiction in which the Licensed App was obtained. In particular, but without limitation, the App may not be exported or
            re-exported (a) into any U.S. embargoed countries or (b) to anyone on the U.S. Treasury Department&apos;s list of Specially
            Designated Nationals or the U.S. Department of Commerce Denied Person&apos;s List or Entity List. By using the App, you
            represent and warrant that you are not located in any such country or on any such list. You also agree that you will not use
            these products for any purposes prohibited by United States law, including, without limitation, the development, design,
            manufacture or production of nuclear, missiles, or chemical or biological weapons.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            US Government Rights.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            The App and related documentation are &quot;Commercial Items&quot;, as that term is defined at 48 C.F.R. &#167;2.101, consisting
            of &quot;Commercial Computer Software&quot; and &quot;Commercial Computer Software Documentation&quot;, as such terms are used
            in 48 C.F.R. &#167;12.212 or 48 C.F.R. &#167;227.7202, as applicable. Consistent with 48 C.F.R. &#167;12.212 or 48 C.F.R.
            &#167;227.7202-1 through 227.7202-4, as applicable, the Commercial Computer Software and Commercial Computer Software
            Documentation are being licensed to U.S. Government end users (a) only as Commercial Items and (b) with only those rights as are
            granted to all other end users pursuant to the terms and conditions herein. Unpublished-rights reserved under the copyright laws
            of the United States.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Arbitration Agreement; Class Waiver; Waiver of Trial by Jury.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            PLEASE READ THE FOLLOWING PARAGRAPHS CAREFULLY BECAUSE THEY REQUIRE YOU TO ARBITRATE DISPUTES WITH JOY, AND LIMIT THE MANNER IN
            WHICH YOU CAN SEEK RELIEF FROM US.
          </Text>
          <ul className="feature-copy-17 no-padding">
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Applicability of Arbitration Agreement. All claims and disputes in connection with the Terms or the use of any product or
                service provided by Joy that cannot be resolved informally or in small claims court shall be resolved by binding arbitration
                on an individual basis under the terms set forth below (the &quot;Arbitration Agreement&quot;), except that neither of us
                are required to arbitrate any dispute in which either party seeks equitable and other relief for the alleged unlawful use of
                copyrights, trademarks, trade names, logos, trade secrets, or patents. This Arbitration Agreement applies to you and Joy,
                and to any subsidiaries, affiliates, agents, employees, predecessors in interest, successors, and assigns, as well as all
                authorized or unauthorized users or beneficiaries of services or goods provided under the Terms.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Arbitration Rules. The Federal Arbitration Act governs the interpretation and enforcement of this dispute-resolution
                provision. Arbitration shall be initiated through the American Arbitration Association (&quot;AAA&quot;), an established
                alternative dispute resolution provider (&quot;ADR Provider&quot;) that offers arbitration as set forth in this section. If
                AAA is not available to arbitrate, the parties shall select an alternative ADR Provider. The rules of the ADR Provider shall
                govern all aspects of this arbitration, including but not limited to the method of initiating and/or demanding arbitration,
                except to the extent such rules conflict with the Terms (&quot;Arbitration Rules&quot;). The AAA Consumer Arbitration Rules
                governing the arbitration are available online at www.adr.org or by calling the AAA at 1-800-778-7879. The arbitration shall
                be conducted by a single, neutral arbitrator. Any claims or disputes where the total amount of the award sought is less than
                ten thousand U.S. dollars (US $10,000.00) may be resolved through binding non-appearance-based arbitration, at the option of
                the party seeking relief. For claims or disputes where the total amount of the award sought is ten thousand U.S. dollars (US
                $10,000.00) or more, the right to a hearing will be determined by the Arbitration Rules. Any judgment on the award rendered
                by the arbitrator may be entered in any court of competent jurisdiction.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Additional Rules for Non-appearance Based Arbitration. If non-appearance arbitration is elected as provided above, the
                arbitration shall be conducted by telephone, online, and/or based solely on written submissions; the specific manner shall
                be chosen by the party initiating the arbitration. The arbitration shall not involve any personal appearance by the parties
                or witnesses unless otherwise mutually agreed by the parties.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Authority of the Arbitrator. The arbitrator will decide the rights and liabilities, if any, of you and Joy, and the dispute
                will not be consolidated with any other matters or joined with any other cases or parties. The arbitrator shall have the
                authority to grant motions dispositive of all or part of any claim. The arbitrator shall have the authority to award
                monetary damages and to grant any non-monetary remedy or relief available to an individual under applicable law, the
                Arbitration Rules, and the Terms. The arbitrator shall issue a written award and statement of decision describing the
                essential findings and conclusions on which the award is based, including the calculation of any damages awarded. The
                arbitrator has the same authority to award relief on an individual basis that a judge in a court of law would have. The
                award of the arbitrator is final and binding upon you and Joy.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Waiver of Jury Trial. YOU AND JOY HEREBY WAIVE ANY CONSTITUTIONAL AND STATUTORY RIGHTS TO GO TO COURT AND HAVE A TRIAL IN
                FRONT OF A JUDGE OR A JURY, instead electing that all claims and disputes shall be resolved by arbitration under this
                Arbitration Agreement. Arbitration procedures are typically more limited, more efficient, and less costly than rules
                applicable in court and are subject to very limited review by a court. In the event any litigation should arise between you
                and Joy in any state or federal court in a suit to vacate or enforce an arbitration award or otherwise, YOU AND JOY WAIVE
                ALL RIGHTS TO A JURY TRIAL, instead electing that the dispute be resolved by a judge.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Waiver of Class or Consolidated Actions. ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION AGREEMENT MUST BE
                ARBITRATED OR LITIGATED ON AN INDIVIDUAL BASIS AND NOT ON A CLASS BASIS, AND CLAIMS OF MORE THAN ONE CUSTOMER OR USER CANNOT
                BE ARBITRATED OR LITIGATED JOINTLY OR CONSOLIDATED WITH THOSE OF ANY OTHER CUSTOMER OR USER. Notwithstanding any other
                provision in these Terms, in the event that this subparagraph is deemed invalid or unenforceable, neither you nor we are
                entitled to arbitration and instead all claims and disputes shall be resolved in a court located in Los Angeles County,
                California.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Confidentiality. No part of the procedures shall be open to the public or the media. All evidence discovered or submitted at
                the hearing is confidential and may not be disclosed, except by written agreement of the parties, pursuant to court order or
                unless required by law. Notwithstanding the foregoing, no party shall be prevented from submitting to a court of law any
                information necessary to enforce this Arbitration Agreement, to enforce an arbitration award, or to seek injunctive or
                equitable relief.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Right to Waive. Any or all of the rights and limitations set forth in this Arbitration Agreement may be waived by the party
                against whom the claim is asserted. Such waiver shall not waive or affect any other portion of this Arbitration Agreement.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Small Claims Court. Notwithstanding the foregoing, either you or Joy may bring an individual action in small claims court.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Courts. In any circumstances where the foregoing Arbitration Agreement permits the parties to litigate in court, the parties
                hereby agree to submit to the personal jurisdiction of the courts located in St. Louis, Missouri, for such purpose.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Survival. This Arbitration Agreement will survive the termination of your relationship with Joy.
              </Text>
            </li>
          </ul>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Governing Law; Venue.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            The laws of the State of Washington, excluding its conflicts of law rules, govern your use of the App. Your use of the App may
            also be subject to other local, state, national, or international laws. You agree that any action at law or in equity arising
            out of or relating to the App, the Service or this agreement shall be filed only in the state and federal courts located in King
            County, Washington, and you irrevocably and unconditionally consent and submit to the exclusive jurisdiction of such courts over
            any suit, action or proceeding arising out of the App.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Severability.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            If any provision of these Terms shall be deemed unlawful, void or for any reason unenforceable, then that provision shall be
            deemed severable from these Terms and shall not affect the validity and enforceability of any remaining provisions.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Note to International Users.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            The Service is hosted in the United States. If you are a user accessing the Service from the European Union, Asia, or any other
            region with laws or regulations governing personal data collection, use, and disclosure that differ from United States laws,
            please be advised that through your continued use of the Services, which are governed by U.S. law, you are transferring your
            personal information to the United States and you consent to that transfer.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            ADDITIONAL EULA TERMS APPLICABLE TO IPHONE, IPOD TOUCH OR IPAD APPLICATIONS.
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            Notwithstanding anything to the contrary in the EULA set forth above, the following additional terms shall apply to any
            Applications downloaded for use on the iPhone, iPod Touch or iPad:
          </Text>
          <ul className="feature-copy-17 no-padding">
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Acknowledgement:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                The parties acknowledge that this EULA is concluded solely between such parties, and not with Apple, and Joy, not Apple, is
                solely responsible for the Application and the content thereof. You further acknowledge that the usage rules for the
                Application are subject to any additional restrictions set forth in the Usage Rules for the Apple App Store Terms of Service
                as of the date you download the Application, and in the event of any conflict, the Usage Rules in the App Store shall govern
                if they are more restrictive
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Scope of License:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                The license granted to you is limited to a non-transferable license to use the Applications on any iPhone, iPod touch or
                iPad that you own or control as permitted by the Usage Rules set forth in the Apple App Store Terms of Service.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Maintenance and Support:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                The parties acknowledge that Apple has no obligation whatsoever to furnish any maintenance and support services with respect
                to the Application.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Warranty:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                You acknowledge that Apple is not responsible for any product warranties, whether express or implied by law, with respect to
                the Applications. In the event of any failure of the Application to conform to any applicable warranty, you may notify
                Apple, and Apple will refund the purchase price, if any, paid to Apple for the Application to that end-user; and to the
                maximum extent permitted by applicable law, Apple will have no other warranty obligation whatsoever with respect to the
                Application. The parties acknowledge that to the extent that there are any applicable warranties, any other claims, losses,
                liabilities, damages, costs or expenses attributable to any failure to conform to any such applicable warranty would be the
                sole responsibility of Joy. However, you understand and agree that in accordance with the EULA, Joy has disclaimed all
                warranties of any kind with respect to the Application, the Site and the Service, and therefore, there are no warranties
                applicable to the Applications.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Product Claims:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                The parties acknowledge that as between Apple and Joy, Joy, not Apple, is responsible for addressing any claims of the
                end-user or any third party relating to the Application or the end-user&apos;s possession and/or use of that Application,
                including, but not limited to: (i) product liability claims; (ii) any claim that the Application fails to conform to any
                applicable legal or regulatory requirement; and (iii) claims arising under consumer protection or similar legislation.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Intellectual Property Rights:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                The parties acknowledge that, in the event of any third party claim that the Application or the end-user&apos;s possession
                and use of that Application infringes that third party&apos;s intellectual property rights, Joy, and not Apple, will be
                solely responsible for the investigation, defense, settlement and discharge of any such intellectual property infringement
                claim to the extent required under the EULA.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Legal Compliance:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                You represent and warrant that (i) you are not located in a country that is subject to a U.S. Government embargo, or that
                has been designated by the U.S. Government as a &quot;terrorist supporting” country; and (ii) you are not listed on any U.S.
                Government list of prohibited or restricted parties.
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Developer Name and Address:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                Any end-user questions, complaints or claims with respect to the Application should be directed to:<br></br>
                <br></br>
                Joy Life, Inc.<br></br>
                Address: 790 Brannan Street<br></br>
                San Francisco CA 94103<br></br>
                Phone: 206-588-6869<br></br>
                Email: <a href="mailto:dmca@withjoy.com">dmca@withjoy.com</a>
              </Text>
            </li>
            <li>
              <Text tagName="span" variant="featureHed17" color="purple6">
                Third Party Beneficiary:
              </Text>
              <Text tagName="span" variant="featureCopy17" color="purple6">
                The parties acknowledge and agree that Apple, and Apple&apos;s subsidiaries, are third party beneficiaries of the EULA, and
                that, upon the end-user&apos;s acceptance of the terms and conditions of the EULA, Apple will have the right (and will be
                deemed to have accepted the right) to enforce the EULA against the end-user as a third party beneficiary thereof).
              </Text>
            </li>
          </ul>
        </li>
      </StyledOL>
    </>
  );
};
